export const validateTCKN = (tckn) => {
  if (!tckn || tckn.length !== 11 || !/^\d+$/.test(tckn) || tckn[0] === '0') {
    return false;
  }

  let oddSum = 0;
  let evenSum = 0;
  let first10Total = 0;

  for (let i = 0; i < 9; i += 2) {
    oddSum += parseInt(tckn[i], 10);
  }

  for (let i = 1; i < 9; i += 2) {
    evenSum += parseInt(tckn[i], 10);
  }

  for (let i = 0; i < 10; i++) {
    first10Total += parseInt(tckn[i], 10);
  }

  const digit10 = (oddSum * 7 - evenSum) % 10;
  const digit11 = first10Total % 10;

  return (digit10 === parseInt(tckn[9], 10) && digit11 === parseInt(tckn[10], 10));
};

export const validateBirthDate = (birthDateStr) => {
  if (!birthDateStr || birthDateStr.length !== 10) return false;

  const [day, month, year] = birthDateStr.split('/').map(part => parseInt(part, 10));

  if (isNaN(day) || isNaN(month) || isNaN(year)) return false;
  if (day < 1 || day > 31) return false;
  if (month < 1 || month > 12) return false;

  // Ayın gün sayısı kontrolü
  const daysInMonth = new Date(year, month, 0).getDate();
  if (day > daysInMonth) return false;

  const birthDate = new Date(year, month - 1, day);
  const today = new Date();

  // İleri tarih kontrolü
  if (birthDate > today) return false;

  // 16 yaş kontrolü
  const age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (age < 16 || (age === 16 && monthDiff < 0) ||
    (age === 16 && monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    return false;
  }

  return true;
};

export const validateCardForm = (cardData) => {
  const { cardNumber, cardHolderName, expiryDate, cvc, selectedInstallmentData } = cardData;
  const errors = {};

  if (!cardNumber || cardNumber.length !== 16) {
    errors.cardNumber = 'Geçerli bir kart numarası giriniz';
  }

  if (!cardHolderName || cardHolderName.trim().length < 5) {
    errors.cardHolderName = 'Geçerli bir kart sahibi adı giriniz';
  }

  // Son kullanma tarihi validasyonu
  if (!expiryDate || !expiryDate.match(/^(0[1-9]|1[0-2])\/([0-9]{2})$/)) {
    errors.expiryDate = 'Geçerli bir son kullanma tarihi giriniz (AA/YY)';
  } else {
    const [month, year] = expiryDate.split('/').map(part => parseInt(part, 10));

    if (month < 1 || month > 12) {
      errors.expiryDate = 'Ay değeri 1-12 arasında olmalıdır';
    }

    // Yıl kontrolü
    const currentYear = new Date().getFullYear() % 100;
    if (year < 25) {
      errors.expiryDate = 'Kart son kullanma yılı 2025 ve sonrası olmalıdır';
    }

    // Ay-yıl geçerlilik kontrolü
    const currentDate = new Date();
    const expiryDateObj = new Date(2000 + year, month - 1, 1);

    if (expiryDateObj < currentDate) {
      errors.expiryDate = 'Kartın son kullanma tarihi geçmiş';
    }
  }

  if (!cvc || !cvc.match(/^[0-9]{3}$/)) {
    errors.cvc = 'Geçerli bir CVC giriniz';
  }

  if (!selectedInstallmentData) {
    errors.installment = 'Lütfen bir taksit seçiniz';
  }

  return errors;
};

export const validateInvoiceForm = (invoiceData) => {
  const errors = {};

  if (!invoiceData.ad || invoiceData.ad.trim().length < 2) {
    errors.ad = 'Geçerli bir ad giriniz';
  }

  if (!invoiceData.soyad || invoiceData.soyad.trim().length < 2) {
    errors.soyad = 'Geçerli bir soyad giriniz';
  }

  if (!invoiceData.adres || invoiceData.adres.trim().length < 5) {
    errors.adres = 'Geçerli bir adres giriniz';
  }

  if (!invoiceData.dogumTarihi) {
    errors.dogumTarihi = 'Doğum tarihi giriniz';
  } else if (!validateBirthDate(invoiceData.dogumTarihi)) {
    errors.dogumTarihi = 'Geçerli bir doğum tarihi giriniz (GG/AA/YYYY)';
  }

  if (!invoiceData.telefon || invoiceData.telefon.length < 11 || !/^\d+$/.test(invoiceData.telefon)) {
    errors.telefon = 'Geçerli bir telefon giriniz';
  }

  if (!validateTCKN(invoiceData.tckimlik)) {
    errors.tckimlik = 'Geçersiz TC Kimlik No';
  }

  return errors;
};

export const formatBirthDate = (input) => {
  // Eğer birden fazla ardışık "/" karakteri varsa tek bir "/" ile değiştir
  input = input.replace(/\/+/g, '/');

  // Sadece sayı ve / karakterleri kabul et
  input = input.replace(/[^\d\/]/g, '');

  // GG/AA/YYYY formatına uygun olacak şekilde düzenle
  if (input.length > 0) {
    // Gün kontrolü
    if (input.length === 1 && parseInt(input) > 3) {
      input = '0' + input;
    } else if (input.length === 2) {
      const day = parseInt(input);
      if (day > 31) {
        input = '31';
      } else if (day === 0) {
        input = '01';
      }
      input += '/';
    } else if (input.length > 2 && input.charAt(2) !== '/') {
      input = input.slice(0, 2) + '/' + input.slice(2);
    }

    // Ay kontrolü
    if (input.length === 4 && parseInt(input.slice(3, 4)) > 1) {
      input = input.slice(0, 3) + '0' + input.slice(3, 4);
    } else if (input.length === 5) {
      const month = parseInt(input.slice(3, 5));
      if (month > 12) {
        input = input.slice(0, 3) + '12';
      } else if (month === 0) {
        input = input.slice(0, 3) + '01';
      }
      input += '/';
    } else if (input.length > 5 && input.charAt(5) !== '/') {
      input = input.slice(0, 5) + '/' + input.slice(5);
    }

    // Yıl kontrolü
    if (input.length > 6) {
      // Maksimum 10 karakter (GG/AA/YYYY)
      input = input.slice(0, 10);

      // 16 yaş kontrolü için
      if (input.length === 10) {
        const [day, month, year] = input.split('/').map(part => parseInt(part, 10));
        const birthDate = new Date(year, month - 1, day);
        const today = new Date();

        // Minimum yaş kontrolü
        const minYear = today.getFullYear() - 16;
        const minMonth = today.getMonth() + 1;
        const minDay = today.getDate();

        if (year > minYear || (year === minYear && month > minMonth) ||
          (year === minYear && month === minMonth && day > minDay)) {
          // 16 yaşından küçükse, 16 yaş sınırına ayarla
          input = `${day < 10 ? '0' + day : day}/${month < 10 ? '0' + month : month}/${minYear}`;
        }
      }
    }
  }

  // Başlangıçta veya sonda kalan slash karakterlerini temizle
  input = input.replace(/^\/+|\/+$/g, '');

  return input;
};

export const formatPhoneNumber = (value) => {
  if (value.length === 0) {
    return '05';
  } else if (value.length === 1 && value !== "0") {
    return '05';
  } else {
    const sanitizedValue = value.replace(/[^0-9]/g, '');
    if (sanitizedValue.length > 11) {
      return sanitizedValue.substring(0, 11);
    } else {
      return sanitizedValue;
    }
  }
};

export const formatExpiryDate = (input) => {
  input = input.replace(/\D/g, '');

  // Ay kısmı kontrol
  if (input.length > 0) {
    if (input.length === 1 && input > '1') {
      input = '0' + input;
    } else if (input.length >= 2) {
      const month = parseInt(input.substring(0, 2), 10);
      if (month > 12) {
        input = '12' + input.substring(2);
      } else if (month === 0) {
        input = '01' + input.substring(2);
      }
    }
  }

  // Yıl kısmı kontrol
  if (input.length >= 4) {
    const year = parseInt(input.substring(2, 4), 10);
    if (year < 25) {
      input = input.substring(0, 2) + '25';
    }
  }

  // AA/YY formatını oluştur
  if (input.length >= 2) {
    input = input.slice(0, 2) + '/' + input.slice(2, 4);
  }

  return input;
}; 